












import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class InputMoeda extends Vue {
  @Prop() value!: number;
  @Prop() rules!: unknown;
  @Prop() label!: string;
  @Prop({default: false}) disabled!: boolean;

  // internalValue = 0;

  options = {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 11,
      precision: 2
    };

  get internalValue() {
    return this.value
  }

  set internalValue(v: number) {
    this.$emit('input', +v);
  }
}
